export enum WidgetParent {
    DASHBOARD,
    ARGUMENT,
}
